module.exports = __webpack_public_path__ + "static/media/qunitjs.c99de3f1.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/qunitjs.ico
// module id = 175
// module chunks = 0